import { useContext } from 'react';
import { Text } from '@shared/components/Text';
import { ButtonView, View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { ColorThemeContext } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import styles from './SubformRow.module.css';

interface AddSubformRowProps {
  onAdd(): void;
}

export function AddSubformRow({ onAdd }: AddSubformRowProps) {
  const colors = useContext(ColorThemeContext);

  return (
    <ButtonView fullWidth className={styles.row} onClick={onAdd}>
      <View row centerVertically paddingVertical={1} paddingHorizontal={3}>
        <MBIconV2 name="plus" size={22} color={colors.foregroundActive} />
        <View fill centerVertically paddingLeft={1}>
          <Text size="body1">{i18n('workflowTemplate.createNewSubform')}</Text>
        </View>
      </View>
    </ButtonView>
  );
}
